import { render, staticRenderFns } from "./LaunchingPage.vue?vue&type=template&id=2dc2c2d4&scoped=true&"
import script from "./LaunchingPage.vue?vue&type=script&lang=ts&"
export * from "./LaunchingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2c2d4",
  null
  
)

export default component.exports